import React, { createContext, useContext, useState } from "react";

const BookingContext = createContext();

export const useBookingContext = () => useContext(BookingContext);

export function BookingProvider({ children }) {
  const [DataChange, onDataChange] = useState([]);
  return (
    <BookingContext.Provider value={{ DataChange,onDataChange }}>
      {children}
    </BookingContext.Provider>
  );
}
